import { render, staticRenderFns } from "./tab-header.vue?vue&type=template&id=31606ed2&scoped=true&"
import script from "./tab-header.vue?vue&type=script&lang=js&"
export * from "./tab-header.vue?vue&type=script&lang=js&"
import style0 from "./tab-header.vue?vue&type=style&index=0&id=31606ed2&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31606ed2",
  null
  
)

export default component.exports